import React, { useState, useEffect } from 'react';
import '../css/MySkills.css'
// import bar from './bar';
import { LinearProgress } from '@mui/material';


function MySkills() {

  const [value, setValue] = useState(0);
  const [value90, setValue90] = useState(0);
  const [value95, setValue95] = useState(0);
  const [value85, setValue85] = useState(0);






  useEffect(() => {

    const onScroll = () => {

      let posSkill = document.getElementById("s").getClientRects()[0].top - 400;

      if (window.scrollY >= posSkill) {
        setInterval(() => {
          setValue((newValue) => newValue >= 93 ? newValue = 93 : newValue + 10)
          setValue90((newValue1) => newValue1 >= 95 ? newValue1 = 95 : newValue1 + 10)
          setValue95((newValue2) => newValue2 >= 95 ? newValue2 = 95 : newValue2 + 10)
          setValue85((newValue3) => newValue3 >= 96 ? newValue3 = 96 : newValue3 + 10)



        }, 300);

      }


    };

    window.addEventListener("scroll", onScroll);








  }, []);




  // setInterval(() => {

  //   setValue((newValue)=>newValue == 90 ? newValue = 0 :  newValue + 20)



  // }, 500);


  return (
    <div className="skillsCard" id='s'>
      <h1 className='skillsTitle'>My Skills</h1>

      <div className="skillsContainer">
        {/* <bar/> */}

        <div className="skills">
          {/* <img src={htmlcssImage} alt="" srcset="" />  
              <h4>Html/css</h4> */}
              
          <h4>Html/css JavaScript</h4>
       
          <LinearProgress style={{ width: "90%", borderRadius: 10 }} value={value85} variant="determinate" />
        </div>

        {/*             
            <div className="webdevSkill">
              <img src="https://www.freepnglogos.com/uploads/javascript-png/javascript-logo-transparent-logo-javascript-images-3.png" alt="" srcset="" />  
              <h4>JavaScript</h4>
              <h4>JavaScript</h4>
              <LinearProgress style={{width:"60%",borderRadius:10}} value={80} variant="determinate"/>
            </div> */}


        <div className="skills">
          {/* <img src={javaLogo} alt="" srcset="" />  
              <h4>Java</h4> */}

          <h4>React Js / React native</h4>
          <LinearProgress style={{ width: "90%", borderRadius: 10 }} value={value90} variant="determinate" />
        </div>

        <div className="skills">
          {/* <img  src={pythonLogo} alt="" srcset="" />  
              <h4>Python/Django</h4> */}
          <h4>Python / Django</h4>
          <LinearProgress style={{ width: "90%", borderRadius: 10 }} value={value} variant="determinate" />
        </div>

        <div className="skills">
          {/* <img src={reactLogo} alt="" srcset="" />  
              <h4>React js/React native</h4> */}
          <h4>Java</h4>
          <LinearProgress style={{ width: "90%", borderRadius: 10 }} value={value90} variant="determinate" />
        </div>


        <div className="skills">
          {/* <img id="nodejsImage" src={nodejsLogo} alt="" srcset="" />  
              <h4>Node Js</h4> */}
          <h4>Node Js</h4>
          <LinearProgress style={{ width: "90%", borderRadius: 10 }} value={value95} variant="determinate" />
        </div>


        <div className="skills">
          {/* <img src={androidDevLogo} alt="" srcset="" />  
              <h4>Android dev/Java,Kotlin</h4> */}
          <h4>Android Development / Java,Kotlin</h4>
          <LinearProgress style={{ width: "90%", borderRadius: 10 }} value={value90} variant="determinate" />
        </div>
        <div className="skills">
          {/* <img id="mernLogo" src={MernLogo} alt="" srcset="" />  
              <h4>Full Stack Web Dev</h4> */}
          <h4>React Native Cross App Development</h4>
          <LinearProgress style={{ width: "90%", borderRadius: 10 }} value={value90} variant="determinate" />
        </div>


      </div>


    </div>
  )
}

export default MySkills;
